import React, {useContext, useEffect} from "react";
import Walkthroughs from "../walkthroughs/Walkthroughs";
import {ContentContext} from "@context/ContentContext";
import PracticeQuestions from "../questions/PracticeQuestions";

const WalkthroughsAndQuestions = props => {
    const {hashName, callback} = props;
    const {content} = useContext(ContentContext);

    useEffect(() => {
        callback?.();
    }, []);

    return (
        <div className="flex ch-content-walkthrough-questions-wrapper">
            <div className="ch-lesson-content-two-panel">
                <Walkthroughs conceptId={content.currentConcept.conceptId} />
            </div>
            <div className="ch-lesson-content-two-panel">
                <PracticeQuestions conceptId={content.currentConcept.conceptId} hashName={hashName} />
            </div>
        </div>
    )
}

export default WalkthroughsAndQuestions;